module.exports = __webpack_public_path__ + "img/hyzc.d919c4d4.png";